module.exports = __webpack_public_path__ + "static/media/rbc-wm.58fd2bba.png";